"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FulfillerMultiSelect = _interopRequireDefault(require("./FulfillerMultiSelect"));
require("../styles/FulfillerSelect.css");
var _i18n = require("./i18n");
var _reactI18next = require("react-i18next");
var _consts = require("./utils/consts");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var FulfillerSelect = /*#__PURE__*/
function (_React$Component) {
  _inherits(FulfillerSelect, _React$Component);
  function FulfillerSelect() {
    _classCallCheck(this, FulfillerSelect);
    return _possibleConstructorReturn(this, _getPrototypeOf(FulfillerSelect).apply(this, arguments));
  }
  _createClass(FulfillerSelect, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(_FulfillerMultiSelect.default, {
        accessToken: this.props.accessToken,
        fulfillers: this.props.fulfillers,
        autoSelectMostRecent: this.props.autoSelectMostRecent,
        fulfillersFilterFunction: this.props.fulfillersFilterFunction,
        i18n: this.props.i18n,
        includeArchived: this.props.includeArchived,
        includeId: this.props.includeId,
        includeInternalId: this.props.includeInternalId,
        includeName: this.props.includeName,
        label: this.props.label,
        language: this.props.language,
        onChange: this.props.onChange,
        t: this.props.t,
        selectedFulfillerIds: this.props.selectedFulfillerId ? [this.props.selectedFulfillerId] : undefined,
        multi: false,
        env: this.props.env
      }));
    }
  }]);
  return FulfillerSelect;
}(_react.default.Component);
FulfillerSelect.propTypes = {
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any,
  // Either access token OR a list of fulfillers to display
  accessToken: _propTypes.default.string,
  fulfillers: _propTypes.default.array,
  fulfillersFilterFunction: _propTypes.default.func,
  selectedFulfillerId: _propTypes.default.string,
  // functions and buttons
  onChange: _propTypes.default.func,
  // display
  language: _propTypes.default.string,
  label: _propTypes.default.string,
  includeArchived: _propTypes.default.bool,
  includeId: _propTypes.default.bool,
  includeInternalId: _propTypes.default.bool,
  includeName: _propTypes.default.bool,
  autoSelectMostRecent: _propTypes.default.bool,
  env: _propTypes.default.string
};
FulfillerSelect.defaultProps = {
  language: 'en',
  includeArchived: false,
  includeId: true,
  includeInternalId: false,
  includeName: true,
  autoSelectMostRecent: true,
  env: _consts.EnvironmentKey.Production
};
var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(FulfillerSelect);
exports.default = _default;